<template>
  <div>
    <img
      @click="backPage"
      src="https://img.51xinlong.com/xladmin/static/ecology/detailBack.png"
      class="backIcon"
    />
    <div class="topBanner">
      <img
        v-if="type == 2"
        src="https://img.51xinlong.com/xladmin/static/ecology/yq-bg.png"
      />
      <img
        v-if="type == 3"
        src="https://img.51xinlong.com/xladmin/website/1648902485379.4524_3ad87101.png"
      />
      <img
        v-if="type == 4"
        src="https://img.51xinlong.com/xladmin/static/ecology/lgb-bg.png"
      />
    </div>

    <div
      class="mainshow"
      style="padding-top: 0px; padding-bottom: 0px"
      v-if="type == 2"
    >
      <div class="fwhx">
        <span class="title">服务核心</span>
        <span class="content">
          为用工企业提供高效、便捷、 合规的灵活用工服务体验，
          持续助力企业用工模式转型升级。<br />
          帮助自由职业者自由就 业、合规完税、保障个人纳税信用体系。
        </span>
      </div>

<!--      <div class="yqzc">
        <label>灵活用工园区政策</label>
        <img
          style="display: flex; width: 1067px; height: 567px; margin-top: 76px"
          src="https://img.51xinlong.com/xladmin/static/ecology/yq-show1.png"
        />
      </div> -->

<!--      <div class="lcfa">
        <label>业务流程方案</label>
        <div class="tab">
          <div class="cell" @click="tabIndex = 0">
            专票&差额普票业务
            <span class="underline" v-if="tabIndex == 0">
              <span class="underItem"></span>
            </span>
          </div>
          <div class="cell" @click="tabIndex = 1">
            自然人代开业务
            <span class="underline" v-if="tabIndex == 1">
              <span class="underItem"></span>
            </span>
          </div>
          <div class="cell" @click="tabIndex = 2">
            集群注册业务
            <span class="underline" v-if="tabIndex == 2">
              <span class="underItem"></span>
            </span>
          </div>
        </div>
        <div class="fullLine"></div>

        <div class="showBox" v-show="tabIndex == 0">
          <div class="itemLabel" style="margin-top: 85px; margin-bottom: 51px">
            专票业务流程方案
          </div>
          <img
            style="width: 950px; height: 552px"
            src="https://img.51xinlong.com/xladmin/static/ecology/yq-show2.png"
          />
          <div class="itemLabel" style="margin-top: 114px; margin-bottom: 59px">
            差额普票业务流程方案
          </div>
          <img
            style="width: 656px; height: 416px; margin-bottom: 166px"
            src="https://img.51xinlong.com/xladmin/static/ecology/yq-show3.png"
          />
        </div>

        <div class="showBox" v-show="tabIndex == 1">
          <div class="itemLabel" style="margin-top: 75px; margin-bottom: 38px">
            自然人代开业务流程方案
          </div>
          <span class="simpleTxt" style="margin-bottom: 14px"
            >将符合条件的共享经济业务下的用工企业和自由职业者的不透明关系通过系统进行有序连接</span
          >
          <span class="simpleTxt"
            >审核用工双方资质、业务真实性，专业风控准入，承担用工信息对接、用工酬劳发放、完善税务合规等职责</span
          >
          <img
            style="width: 624px; height: 264px; margin-top: 48px"
            src="https://img.51xinlong.com/xladmin/static/ecology/yq-show4.png"
          />
          <img
            style="
              width: 1040px;
              height: 495px;
              margin-top: 78px;
              margin-bottom: 133px;
            "
            src="https://img.51xinlong.com/xladmin/static/ecology/yq-show6.png"
          />
        </div>

        <div class="showBox" v-show="tabIndex == 2">
          <div class="itemLabel" style="margin-top: 75px; margin-bottom: 72px">
            集群注册业务流程方案
          </div>
          <img
            style="width: 927px; height: 575px"
            src="https://img.51xinlong.com/xladmin/static/ecology/yq-show5.png"
          />
          <img
            style="
              width: 1040px;
              height: 153px;
              margin-bottom: 126px;
              margin-top: 78px;
            "
            src="https://img.51xinlong.com/xladmin/static/ecology/yq-show7.png"
          />
        </div>
      </div> -->

      <div class="ppys">
        <label>灵活用工品牌优势</label>
        <div class="ppysContent">
          <div class="ppysItem" :key="index" v-for="(item, index) in ppysList">
            <img :src="item.icon" />
            <div class="right">
              <span class="title">
                {{ item.title }}
              </span>
              <span class="content">
                {{ item.content }}
              </span>
            </div>
          </div>
        </div>
      </div>

<!--      <label class="maintitle">四流合一</label>
      <img
        style="width: 555px; height: 395px; margin-top: 63px"
        src="https://img.51xinlong.com/xladmin/static/ecology/yq-siliu.png"
      /> -->
<!--      <div class="fixcompanyPro">
        <div class="txt">
          <span class="title">解决企业问题</span>
          <ul type="disc">
            <li>用工成本优化，规范企业合理用工，降低用人成本；</li>
            <li>解决企业无票支出、税务风险、财务合规问题；</li>
            <li>解决高净值自由职业者税负过高问题；</li>
            <li>合理降低用工风险；</li>
          </ul>
        </div>
        <img
          style="
            width: 1200px;
            height: 400px;
            margin-top: 93px;
            margin-bottom: 109px;
          "
          src="https://img.51xinlong.com/xladmin/static/ecology/fixCompany.png"
        />
      </div> -->

      <label class="maintitle" style="margin-bottom: 54px">实施落地</label>

      <span class="simpleTxt" style="margin-bottom: 14px"
        >将符合条件的共享经济业务下的用工企业和自由职业者的不透明关系通过系统进行有序连接</span
      >
      <span class="simpleTxt"
        >审核用工双方资质、业务真实性，专业风控准入，承担用工信息对接、用工酬劳发放合规等职责</span
      >
      
      <div style="margin-bottom: 120px;"></div>
      
<!--      <div class="ygcj">
        <label style="margin-bottom: 55px">用工场景举例</label>
        <img
          style="width: 1121px; height: 620px"
          src="https://img.51xinlong.com/xladmin/static/ecology/yq-bottom.png"
        />
      </div> -->
    </div>

    <div class="mainshow" style="padding-top: 6.3125rem" v-if="type == 3">
      <label class="wrap3Title">产品亮点</label>
      <div class="cell cell3">
        <div
          class="cell-item"
          style="width: 373px; margin-bottom: 0px"
          :key="index"
          v-for="(item, index) in cellList3"
        >
          <img class="icon" :src="item.icon" />
          <label style="width: 200px; text-align: left">{{ item.name }}</label>
          <div class="str" style="margin-left: 0px" v-html="item.htmlStr"></div>
        </div>
      </div>

      <label class="wrap3Title">保险方案</label>
      <div class="jjplan plan1">
        <img
          class="img-bxfa"
          src="https://img.51xinlong.com/xladmin/static/ecology/lbb-pc1.png"
        />
        <span class="span1">保险说明</span>
        <span class="span2"
          >残疾赔付：根据当地劳动部门或司法鉴定机构鉴定等级进行赔付<br />误工津贴：0免赔，每次90天，累计180天</span
        >
      </div>

      <label class="wrap3Title" style="margin-top: 89px">对接说明</label>
      <div class="jjplan plan2" style="height: 486px">
        <img
          class="img-djsm"
          src="https://img.51xinlong.com/xladmin/static/ecology/lbb-pc2.png"
        />
      </div>
    </div>

    <div class="mainshow" v-if="type == 4">
      <div class="topbgIconArea">
        <img
          class="topbgIcon"
          src="https://img.51xinlong.com/xladmin/static/ecology/lgd-1.png"
        />
        <div class="topbgIconTitle">
          <label class="label3">灵工贷介绍</label>
          <p class="label4">
            法人通过支付宝在线申请贷款，贷款资金发放至企业支付宝，
            再通过支付宝及生态合作伙伴平台发给C端支付宝。
          </p>
        </div>
      </div>
      <div class="cell">
        <div class="cell-item" :key="index" v-for="(item, index) in cellList">
          <img class="icon" :src="item.icon" />
          <label>{{ item.name }}</label>
          <div class="str" v-html="item.htmlStr"></div>
        </div>
      </div>

      <div class="youshi">
        <label class="title">灵工贷优势</label>
        <div class="youshi-wrap">
          <div class="youshi-itemWrap">
            <div
              class="youshi-item"
              :key="index"
              v-for="(item, index) in ysList"
            >
              <img :src="item.icon" />
              <div class="ys-title">{{ item.name }}</div>
              <div v-html="item.str"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tabIndex: 0,
      type: 0,
      ppysList: [
        {
          icon: "https://img.51xinlong.com/xladmin/static/ecology/yq-ys1.png",
          title: "资金安全解决方案",
          content:
            "全行业独家推出“支付宝”安全发，企业客户不用再对公打款平台账户，只需企业支付宝即可发起下发，秒过平台账户，秒发至C端自由职业者账户。",
        },
        {
          icon: "https://img.51xinlong.com/xladmin/static/ecology/yq-ys2.png",
          title: "安心的技术风控",
          content:
            "内部风控确保业务合法、真实，符合灵活用工场景；独立共管子账户、api对接实现提现、T+o万笔秒发；内部风控确保业务合法、真实，符合灵活用工场景；内部风控确保业务合法、真实，符合灵活用工场景；所有自由职业者服务数据100%在系统中沉淀。",
        },
        {
          icon: "https://img.51xinlong.com/xladmin/static/ecology/yq-ys3.png",
          title: "专业的技术能力服务",
          content:
            "实现与客户系统全面对接，系统智能同步客户系统和我们系统操作C端从客户平台提现到我们系统支付给C端全部自动完成。以及快速OEM服务。",
        },
        {
          icon: "https://img.51xinlong.com/xladmin/static/ecology/yq-ys4.png",
          title: "优质的政府资源",
          content:
            "平台拥有全国多个省份/区域授权资质的服务公司资源，保障平台强大的服务能力,帮助客户享受灵活用工政策，服务资质多样化。",
        },
        {
          icon: "https://img.51xinlong.com/xladmin/static/ecology/yq-ys5.png",
          title: "业务成熟",
          content:
            "目前服务企业10000+，80%是行业知名企业，自由职业者1000000+。",
        },
        {
          icon: "https://img.51xinlong.com/xladmin/static/ecology/yq-ys6.png",
          title: "51灵活就业网&小程序",
          content:
            "支持自然人委托代征电子签约实名认证。",
        },
      ],
      ysList: [
        {
          name: "纯信用",
          icon: "https://img.51xinlong.com/xladmin/static/ecology/lgd-icon5.png",
          str: '<p class="ysStr">无需抵押或担保</p>',
        },
        {
          name: "额度高",
          icon: "https://img.51xinlong.com/xladmin/static/ecology/lgd-icon6.png",
          str: '<p class="ysStr" style="width:171px;">自动审批最高<span class="c3">200</span>万； 优质客户可人工提额， 最高<span class="c3">800</span>万</p>',
        },
        {
          name: "利率低",
          icon: "https://img.51xinlong.com/xladmin/static/ecology/lgd-icon7.png",
          str: '<p class="ysStr" style="width:190px;">年化[6.57%-10.04%]，<span class="c3">日息平均万分之2.45</span>， 除利息外无其他费用</p>',
        },
        {
          name: "随借随还",
          icon: "https://img.51xinlong.com/xladmin/static/ecology/lgd-icon8.png",
          str: '<p class="ysStr" style="width:188px;">循环额度，支持部分或全额提前还款，按日计息</p>',
        },
        {
          name: "线上操作",
          icon: "https://img.51xinlong.com/xladmin/static/ecology/lgd-icon9.png",
          str: '<p class="ysStr">全程支付宝 在线操作</p>',
        },
        {
          name: "下款快",
          icon: "https://img.51xinlong.com/xladmin/static/ecology/lgd-icon10.png",
          str: '<p class="ysStr" style="width:167px;">3分钟出授信结果，提款实时到账</p>',
        },
        {
          name: "多发多贷",
          icon: "https://img.51xinlong.com/xladmin/static/ecology/lgd-icon11.png",
          str: '<p class="ysStr">代发流水越高授信额度越高</p>',
        },
      ],
      cellList3: [
        {
          name: "支持灵活定制",
          icon: "https://img.51xinlong.com/xladmin/static/ecology/lbb-icon1.png",
          htmlStr: '<p class="ptr">新业态专用险种、无雇佣关系</p>',
        },
        {
          name: "保障全面",
          icon: "https://img.51xinlong.com/xladmin/static/ecology/lbb-icon2.png",
          htmlStr: '<p class="ptr">行业覆盖广、险种齐全</p>',
        },
        {
          name: "专业服务",
          icon: "https://img.51xinlong.com/xladmin/static/ecology/lbb-icon3.png",
          htmlStr:
            '<p class="ptr"><span class="c31">7*24小时</span>专属顾问服务 <br/>专业团队指导</p>',
        },
      ],
      cellList: [
        {
          name: "额度",
          icon: "https://img.51xinlong.com/xladmin/static/ecology/lgd-icon1.png",
          htmlStr:
            '<p class="ptr">法人授信，额度最高<span class="c1">800万元，纯信用无抵押</span><br />新客可通过支付宝扫发票获取初始额度</p>',
        },
        {
          name: "利率",
          icon: "https://img.51xinlong.com/xladmin/static/ecology/lgd-icon2.png",
          htmlStr:
            '<p class="ptr">最低可至日息<span class="c2">万分之1.8</span>（年化6.57%），<span class="c2">最高不超过 万分之2.75</span> ，无任何额外费用</p>',
        },
        {
          name: "账户",
          icon: "https://img.51xinlong.com/xladmin/static/ecology/lgd-icon3.png",
          htmlStr:
            '<p class="ptr"><span class="c3">在线开通网商银行账户</span>，无须线下资料，方便开户<br /><span class="c3">对公账户放款</span>，不影响做账、开票和报税</p>',
        },
        {
          name: "还款",
          icon: "https://img.51xinlong.com/xladmin/static/ecology/lgd-icon4.png",
          htmlStr:
            '<p class="ptr"><span class="c4">按日计息随借随还</span>，可随时提前还款</p>',
        },
      ],
    };
  },
  methods: {
    backPage() {
      this.$router.go(-1);
    },
  },
  mounted() {
    this.type = this.$route.query.type;
  },
};
</script>

<style>
.backIcon {
  position: fixed;
  right: 14vw;
  top: 0px;
  width: 5vw;
  display: flex;
  z-index: 9999;
  cursor: pointer;
  transition: all ease-in-out 0.3s;
}
.backIcon:hover {
  transform: scale(1.2);
}
.showBox {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.fullLine {
  width: 100%;
  height: 1px;
  background-color: #d1d1d1;
}
.ygcj {
  height: 920px;
  width: 100%;
  background: #f7fbff;
  margin-top: 100px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  padding-top: 127px;
  box-sizing: border-box;
}

.simpleTxt {
  font-size: 18px;
  font-family: PingFang;
  font-weight: 400;
  color: #282828;
}

.fixcompanyPro {
  position: relative;
}

.fixcompanyPro ul {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 30px;
}

.fixcompanyPro .txt {
  position: absolute;
  left: 138px;
  top: 156px;
}

.fixcompanyPro .txt .title {
  font-size: 36px;
  font-family: PingFang;
  font-weight: 500;
  color: #ffffff;
  margin-bottom: 38px;
}

.maintitle {
  font-size: 36px;
  font-family: PingFang;
  font-weight: 500;
  color: #292929;
}

.ppys {
  height: 750px;
  width: 100%;
  background: #f7fbff;
  flex-direction: column;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-top: 115px;
  box-sizing: border-box;
  margin-bottom: 97px;
}

.ppysContent {
  width: 1201px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  margin-top: 109px;
}

.ppysItem {
  width: 343px;
  height: auto;
  margin-right: 86px;
  display: flex;
}

.ppysItem img {
  width: 48px;
  height: 48px;
  margin-right: 30px;
}

.ppysItem .title {
  margin-bottom: 24px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #292929;
}

.ppysItem .content {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: #6b6b6b;
  line-height: 22px;
  margin-bottom: 58px;
}

.ppysItem .right {
  display: flex;
  flex-direction: column;
}

.ppysItem:nth-child(3),
.ppysItem:nth-child(6) {
  margin-right: 0px;
}

.yqzc {
  height: 900px;
  width: 100%;
  background-color: #f7fbff;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 90px;
  flex-direction: column;
}

.lcfa {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.lcfa .tab {
  display: flex;
  margin-top: 48px;
  flex-direction: row;
  width: 100%;
  height: auto;
  justify-content: center;
  align-items: center;
}

.lcfa .tab .cell {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  margin-right: 56px;
  display: flex;
  height: 42px;
  width: auto;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  margin-top: 0px !important;
}

.lcfa .tab .underline {
  position: absolute;
  bottom: 0px;
  left: 0px;
  width: 100%;
  height: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.underItem {
  width: 73px;
  height: 100%;
  background-color: #0080ff;
  border-radius: 80px;
  margin-bottom: -6px;
}

.lcfa .tab span:last-child {
  margin-right: 0px;
}

.yqzc label,
.lcfa label,
.ppys label,
.ygcj label {
  font-size: 32px;
  font-family: PingFang;
  font-weight: 500;
  color: #000000;
}

.itemLabel {
  width: 100%;
  text-align: center;
  font-size: 32px;
  font-family: PingFang;
  font-weight: bold;
  color: #292929;
}

.fwhx {
  height: 300px;
  width: 100%;
  padding-top: 105px;
  box-sizing: border-box;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
}

.fwhx .title {
  font-size: 32px;
  font-family: PingFang;
  font-weight: 500;
  color: #000000;
  margin-bottom: 41px;
}

.fwhx .content {
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: #292929;
  line-height: 28px;
}

.plan1 {
  padding-top: 52px;
  box-sizing: border-box;
}
.plan1 span {
  display: flex;
  width: 1121px;
  margin-left: 13px;
}

.plan1 .span1 {
  font-size: 18px;
  font-weight: 500;
  font-family: PingFang;
  color: #292929;
  margin-bottom: 12px;
}

.plan1 .span2 {
  font-size: 14px;
  font-weight: 400;
  font-family: PingFang;
  color: #4d4d4d;
}

.plan2 {
  padding-top: 127px;
  box-sizing: border-box;
}
img.img-bxfa {
  width: 1121px;
  height: 674px;
  margin-bottom: 31px;
}

.img-djsm {
  width: 732px;
  height: 293px;
}
.jjplan {
  height: 900px;
  width: 1400px;
  background: #fafafa;
  margin-top: 28px;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
}
.wrap3Title {
  width: 75.25rem;
  text-align: left;
  font-family: PingFang;
  font-size: 2.25rem;
  color: #292929;
  font-weight: 500;
  padding-left: 3.25rem;
  box-sizing: border-box;
}

.topbgIconArea {
  position: relative;
}

.topbgIconTitle {
  position: absolute;
  left: 7.625rem;
  top: -30px;
  font-family: PingFang;
}
.label3 {
  font-size: 3.125rem;
  font-weight: 500;
  color: #292929;
}
.label4 {
  width: 525px;
  margin-top: 1.875rem;
  font-family: PingFang;
  font-size: 1.25rem;
  color: #292929;
  font-weight: 400;
  line-height: 30px;
}

.ysStr {
  line-height: 1;
  margin: 0px;
  margin-top: 2.5rem;
  color: #808080;
  font-size: 1rem;
  font-weight: 400;
  line-height: 30px;
  font-family: PingFang;
}
.c31 {
  color: #e28149;
  font-weight: 800;
}
.c1 {
  color: #efab22;
  font-weight: 800;
}
.c2 {
  color: #4c29f1;
  font-weight: 800;
}
.c3 {
  color: #006afe;
  font-weight: 800;
}
.c4 {
  color: #e28149;
  font-weight: 800;
}
.cell {
  width: 75.25rem;
  height: auto;
  margin-top: 4.5625rem;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
}
.cell3 {
  margin-top: 3.1875rem;
  margin-bottom: 7.625rem;
}

.cell-item {
  width: 36.25rem;
  height: 17.75rem;
  border: 1px solid #e5e5e5;
  border-radius: 15px;
  margin-bottom: 2.5rem;
  padding: 1.875rem 0rem 0rem 3.5rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.str {
  margin-left: 0.75rem;
  font-size: 18px;
}

.ptr {
  line-height: 30px;
  width: 26.3125rem;
  color: #808080;
  font-family: PingFang;
}

.cell-item .icon {
  width: 4.375rem;
  height: 4.375rem;
  margin-bottom: 2.375rem;
}

.cell-item label {
  width: 70px;
  text-align: center;
  font-size: 24px;
  font-weight: 500;
  color: #292929;
  margin-bottom: 0.8rem;
}

.youshi {
  margin-top: 4.25rem;
}
.youshi .title {
  display: flex;
  margin-left: 6.375rem;
  margin-bottom: 2.875rem;
  font-size: 3.125rem;
  font-weight: 500;
  font-family: PingFang;
  color: #000;
}
.youshi-wrap {
  width: 87.5rem;
  height: 53.5625rem;
  background-color: #fafafa;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 7.5625rem 0rem;
  box-sizing: border-box;
}

.youshi-itemWrap {
  width: 77.5rem;
  height: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-content: space-between;
}

.youshi-item {
  width: 19.3125rem;
  height: 232px;
  border-right: 1px solid #e5e5e5;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
}

.ys-title {
  margin-top: 2.1875rem;
  font-size: 1.5rem;
  font-family: PingFang;
  font-weight: 500;
  color: #292929;
}

.youshi-item:nth-child(4) {
  border-right: 0px;
}

.topBanner {
  /* height: 37.5rem; */
  display: flex;
  width: 100%;
  background-color: #fff;
  position: relative;
}

.bannerTitle {
  position: absolute;
  /* 		left: 22.4375rem;
		top: 13.25rem; */
  left: 18.697%;
  top: 35.333%;
  color: #fff;
  display: flex;
  flex-direction: column;
  font-family: Microsoft YaHei;
}

.label1 {
  font-size: 5.625rem;
  font-family: Microsoft YaHei;
  font-weight: bold;
}
.label2 {
  font-size: 2rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  margin-top: 2.0625rem;
}

.topBanner img {
  width: 100%;
}

.mainshow {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-top: 7.1875rem;
  box-sizing: border-box;
  flex-direction: column;
  padding-bottom: 6.375rem;
}

.topbgIcon {
  width: 85.625rem;
  height: auto;
  margin-left: 4.625rem;
}
</style>
